import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const { handleGoogleSuccess } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  async function onSuccess(credentialResponse) {
    setError('');
    const result = await handleGoogleSuccess(credentialResponse);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
  }

  function onError() {
    setError('Google sign-in failed. Please try again.');
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-mark">
            <span className="brand-arf">ARF</span>
            <span className="brand-divider">x</span>
            <span className="brand-cc">CC</span>
          </div>
          <h1 className="login-title">Market Ops</h1>
          <p className="login-subtitle">Apple Ridge Farm & Collective Culture</p>
        </div>
        <div className="login-action">
          <p className="login-prompt">Sign in with your Google account</p>
          <GoogleLogin
            onSuccess={onSuccess}
            onError={onError}
            useOneTap
            theme="outline"
            size="large"
            width="280"
          />
          {error && <div className="login-error">{error}</div>}
        </div>
        <p className="login-footer">Need access? Contact your admin.</p>
      </div>
    </div>
  );
}
